import { useSiteSettings } from "@/hooks/useSiteSettings";

/**
 * Mode commercial du site.
 * - freeMode = true : tous les abonnements pro sont gratuits (lancement).
 *   Les prix sont affichés barrés et un badge "Offert actuellement" apparaît.
 * - freeMode = false : tarifs normaux, abonnement requis pour les pros.
 *
 * Piloté par le réglage `pro_subscription_enabled` (déjà utilisé par
 * is_pro_active() côté base de données).
 */
export function useCommercialMode() {
  const { getSetting, loading } = useSiteSettings();
  const freeMode = getSetting("pro_subscription_enabled", "true") === "false";
  const freeLabel = getSetting("free_mode_label", "Offert actuellement");
  const badgeText = getSetting("free_mode_badge_text", "Gratuit pendant le lancement 🎉");
  return { freeMode, freeLabel, badgeText, loading };
}
